import * as Dialog from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useNavigate } from 'react-router-dom';

type ModalType = 'save' | 'export';

interface AuthRequiredModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  type: ModalType;
}

export default function AuthRequiredModal({
  isOpen,
  onOpenChange,
  type,
}: AuthRequiredModalProps) {
  const navigate = useNavigate();
  const imageToImageState = useSelector((state: RootState) => state.imageToImage);

  const handleLogin = () => {
    // Save current state to localStorage
    const stateToSave = {
      fileName: imageToImageState.fileName,
      generatedImageUrl: imageToImageState.generatedImageUrl,
      selectedStyle: imageToImageState.selectedStyle,
      action: type,
    };
    localStorage.setItem('imageToImageState', JSON.stringify(stateToSave));
    
    // Navigate to login
    navigate('/auth/login');
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50" />
        <Dialog.Content className="fixed text-text-primary left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rounded-lg bg-background p-6 shadow-lg w-[400px] max-w-[calc(100%-32px)]">
          <div className="flex flex-col gap-4">
            <Dialog.Title className="text-2xl font-bold text-primary">
              Login Required
            </Dialog.Title>
            
            <p className="text-sm">
              {type === 'save' 
                ? 'You need to be logged in to save this image to your account.' 
                : 'You need to be logged in to export this image.'}
            </p>

            <div className="flex justify-end gap-2 mt-2">
              <Button
                onClick={() => onOpenChange(false)}
                variant="customSecondary"
                size="sm"
              >
                Cancel
              </Button>
              <Button
                onClick={handleLogin}
                variant="customPrimary"
                size="sm"
              >
                Login
              </Button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
} 